import { useStoreSelector } from 'v3/data/store';
import { StoreProfileEnum } from 'v3/data/store/stores/enums';
import Footer from 'v3/shared/components/Footer';
import { NavBar } from 'v3/shared/components/NavBar';
import { OnlineNavBar } from 'v3/shared/components/OnlineNavBar';
import { TemplateBody, TemplateContainer } from 'v3/shared/templates/styles';
import { IDefaultTemplate } from './types';

export const CommonTemplate: React.FC<IDefaultTemplate> = ({ children }) => {
  const { group, id } = useStoreSelector((store) => store.store.storeLogged);
  const inApp = group === StoreProfileEnum.IN_APP;
  return (
    <TemplateContainer>
      {inApp ? <OnlineNavBar /> : <NavBar />}
      <TemplateBody>{children}</TemplateBody>
      <Footer />
    </TemplateContainer>
  );
};
